import { roleEnum } from '../../../constants';
import { formatTimeNoYear } from '../../../utils';
import React from 'react';
import Avatar from '../../../Avatar';
import HOT from '../../img/hot.png';
import PropTypes from 'prop-types';

import styles from './index.css';

const Header = ({
    needHotLogo = true,
    dataInfo,
    useInfo,
    headChildren,
    hiddenOwnerTag = false,
    additionalUserInfo,
    needEditInfo = false,
}) => {
    const { ctime, utime, endTime, editFlag } = dataInfo || {};
    const { vip, profession } = additionalUserInfo || {};
    const { avatar: logo, nickName: name, roleList } = useInfo || {};

    return (
        <div className={styles.header}>
            {Number(dataInfo?.boutique) === 1 && needHotLogo && <img className={styles.hot} src={HOT} alt="" />}
            <div className={styles.logo}>
                <Avatar noSize src={logo} />
                <span className={`${styles[vip]} ${styles.v_info}`} />
            </div>

            <div className={styles.right}>
                <span className={styles.name}>
                    <span className={styles.name1}>{name || '凤凰网友'}</span>
                    {!hiddenOwnerTag &&
                        roleList?.indexOf(roleEnum.OWNER) > -1 && <span className={styles.owner}>圈主</span>}
                </span>
                <div className={styles.tip}>
                    {endTime ? formatTimeNoYear(endTime) : formatTimeNoYear(ctime)}
                    {needEditInfo && editFlag !== 'publish' && <span className={styles.profession}>已编辑</span>}
                    {profession && <span className={styles.profession}>{profession}</span>}
                </div>
            </div>
            <div>{headChildren}</div>
        </div>
    );
};

Header.propTypes = {
    /**
     * 是否需要热门的标识，默认需要
     */
    needHotLogo: PropTypes.bool,
    dataInfo: PropTypes.object.isRequired,
    useInfo: PropTypes.object.isRequired,
    /**
     * 头部扩展元素
     */
    headChildren: PropTypes.any,
    /**
     * 隐藏圈主标签
     */
    hiddenOwnerTag: PropTypes.bool,
    additionalUserInfo: PropTypes.object,
    needEditInfo: PropTypes.bool,
};

export default Header;
